<template>
    <div class="row gx-3">
        <pc-input-group class="col-12">
            <pc-checkbox
                v-bind:validation-group-id="inputId"
                v-bind="binder"
                v-bind:label="label"
                v-bind:help-link="showHelpLinkOnly"
                data-test-role="checkbox-element"
                v-on="listeners"
                v-on:help-clicked="emitHelpClicked" />
        </pc-input-group>
        <div class="col-12">
            <slot name="help" />
        </div>
        <validation-render-helper
            v-bind:validation-group-id="inputId"
            v-bind:validation-error="validationError" />
    </div>
</template>

<script>
    import base, { validationRenderHelper } from "./_elementBase";
    export default {
        components: { validationRenderHelper },
        extends: base,
        methods: {
            getValueOverride(value) {
                if (typeof value === "boolean") {
                    return value;
                }
                if (value == null) {
                    return false;
                }
                return Boolean(value.toLowerCase() === "true");
            }
        }
    };
</script>
